module.exports = __webpack_public_path__ + "94a5f22e464ad7dbe284e6054ddf76f0.png";